import o from "./useMediaQuery.mjs";
const r = "@media (prefers-reduced-motion: reduce)", e = typeof navigator < "u" && navigator.userAgent.match(/android\s(\d+)|OS\s(\d+)/i), n = e && e[1] ? parseInt(e[1], 10) : null, s = e && e[2] ? parseInt(e[2], 10) : null, t = n && n < 10 || s && s < 13 || !1, d = () => o(r, {
  defaultMatches: !1
}) || t;
export {
  t as slowAnimationDevices,
  d as useDefaultReduceAnimations
};
//# sourceMappingURL=useDefaultReduceAnimations.mjs.map
